import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

/**
 * Desktop-only left rail. Mobile hides this entirely — bottom nav
 * + overflow menu cover the same surface area in the thumb zone.
 */

export interface NavItem {
  to: string;
  label: string;
}

export const NAV: ReadonlyArray<NavItem> = [
  { to: '/', label: 'Dashboard' },
  { to: '/domains', label: 'Domains' },
  { to: '/guides', label: 'Guides' },
  { to: '/checklists', label: 'Checklists' },
  { to: '/logs', label: 'Logs' },
  { to: '/photos', label: 'Photos' },
  { to: '/inventory', label: 'Inventory' },
  { to: '/equipment', label: 'Equipment' },
  { to: '/projects', label: 'Projects' },
  { to: '/vendors', label: 'Vendors' },
  { to: '/references', label: 'References' },
  { to: '/settings', label: 'Settings' },
];

export default function Sidebar() {
  return (
    <nav className="space-y-0.5 text-sm">
      {/* Section label — small mono "binder tab" hint above the route
          list. Establishes the field-instrument feel without adding
          chrome. */}
      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground pb-2 pl-3">
        Navigate
      </p>
      {NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            cn(
              'flex items-center rounded-md px-3 py-2 transition-colors',
              isActive
                ? 'bg-accent text-accent-foreground font-medium'
                : 'text-foreground/80 hover:bg-muted hover:text-foreground',
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
